module.exports = __webpack_public_path__ + "img/orbital-station.d58193ae.jpg";